// "use strict";

angular.module('app.factories.apiAlarm', []). // app.factories.apiAlarm-module

// -------------------------------------------//
//             Alarm Factory
// -------------------------------------------//


factory('ApiAlarmService', ['$rootScope', 'f_Info', 'xCenterConfig', 'API', '$q',
    function ($rootScope, f_Info, xCenterConfig, API, $q) {
        var as = {};
        var alarmHistory = [];
        as.apialarms = [];

        // -------------------------------------------//
        //              Fetch from API
        // -------------------------------------------//
        as.fetchCurrentAlarms = function () {
            var defer = $q.defer();

            var api = new API();
            var getCurrentAlarmsParams = {
                'DeviceId': xCenterConfig.var.guid_All
            };
            api.Alarm.GetCurrentAlarms(getCurrentAlarmsParams).$promise
            .then(function(data) {
                as.parseCurrentAlarms(angular.copy(data));
                defer.resolve(data);
            });

            return defer.promise;
        };

        // -------------------------------------------//
        //             'Get Alarms'
        // -------------------------------------------//
        as.getCurrentAlarms = function () {
            return as.apialarms;
        };



        // -------------------------------------------//
        //             'Get Alarms Request'
        // -------------------------------------------//
        as.getProblemsPromise = function () {
            var api = new API();
            var getCurrentAlarmsParams = {
                'DeviceId': xCenterConfig.var.guid_All
            };
            return api.Alarm.GetCurrentAlarms(getCurrentAlarmsParams).$promise;
        };

        // -------------------------------------------//
        //             'Get Alarms'
        // -------------------------------------------//
        as.parseCurrentAlarms = function (a) {
            for (var i = as.apialarms.length - 1; i >= 0; i--) {
                var found = false;
                for (var j = a.length - 1; j >= 0; j--) {
                    if (a[j].AlarmEntryId == as.apialarms[i].AlarmEntryId) {
                        found = true;
                        if (as.apialarms[i].showDetails == true) {
                            a[j].showDetails = true;
                        }
                        ;
                        var nO = a[j];
                        a.splice(j, 1);
                        as.apialarms[i] = nO;
                        break;
                    }
                }
                if (found == false) {
                    as.apialarms.splice(i, 1);
                }
            }
            for (var j = a.length - 1; j >= 0; j--) {
                as.apialarms.push(a[j]);
            }
            as.setCurrentAlarms(as.apialarms);
        };


        // -------------------------------------------//
        //             Set Alarms
        // -------------------------------------------//
        as.setCurrentAlarms = function (data) {
            as.apialarms = data;

            if (as.apialarms.length > 0) {
                $rootScope.$broadcast('currentAlarmsUpdate');
            }

            for (var i = 0; i < as.apialarms.length; i++) {

                var a = as.apialarms[i];
                if (a.AlarmType == 10) {
                    f_Info.addInfo(
                        {
                            "DisplayText": a.ShortText
                        }
                    );
                    //console.log('ApiAlarmService -> setCurrentA -> push:');
                }
            }
            return as;
        };


        // -------------------------------------------//
        //              Fetch Alarm History
        // -------------------------------------------//
        as.fetchAlarmHistory = function (o, shouldSet) {
            if (o === undefined
                || o.start === undefined
                || o.count === undefined
                || o.fromUtc === undefined
                || o.toUtc === undefined) {
                console.warn('Wrong fetchAlarmHistory parameters!');
                return [];
            }

            var api = new API();
            var getCurrentAlarmsParams = {
                "DeviceId": xCenterConfig.var.guid_All,
                "Count": o.count,
                'Start': o.start,
                'fromUtc': o.fromUtc,
                'toUtc': o.toUtc,
            };
            return api.Alarm.GetAlarmHistory(getCurrentAlarmsParams).$promise
            .then(function (data) {
                var r = data;
                if (shouldSet !== undefined) {
                    as.setAlarmHistory(r);
                }

                if (o.fn !== undefined) {
                    o.fn(r);
                }

                return r;
            });
        };


        // -------------------------------------------//
        //              Get Alarm History
        // -------------------------------------------//
        as
            .getAlarmHistory = function () {
            return alarmHistory;
        };

        // -------------------------------------------//
        //             Set Alarm History
        // -------------------------------------------//
        as.setAlarmHistory = function (d) {
            alarmHistory = d;
            $rootScope.$broadcast('alarmHistoryUpdate');
            return as;
        };


        return as;


    }
]);
